.DateContainer
    width: 100%
    margin: 0
    padding: 0
    color: rgb($globalSettingsFontPrimary)
    white-space: nowrap
    clear: both
    box-sizing: border-box
    stroke: rgb($globalSettingsFontSecondary)
    display: flex
    gap: 4px
    align-items: center

.S
    font-size: 12px

.M
    font-size: 14px
